import { ReactNode } from 'react'
import Sidebar from './Sidebar'
import Header from './Header'
import { AIPanel } from './AIPanel'

interface LayoutProps {
  children: ReactNode
}

export default function Layout({ children }: LayoutProps) {
  return (
    <div className="min-h-screen bg-apple-gray-50 flex">
      <Sidebar />
      <div className="flex-1 flex flex-col min-w-0">
        <Header />
        <main className="flex-1 overflow-auto p-6">
          {children}
        </main>
      </div>
      <AIPanel />
    </div>
  )
}
